import gsap from 'gsap';
import $ from '../core/Dom';

export default el => {

    const $el = $(el);
    const $embed = $el.find('[data-embed]');
    const $poster = $el.find('[data-poster]');

    let hasClicked = false;

    const onClick = e => {
        e.preventDefault();
        if (hasClicked) {
            return;
        }
        hasClicked = true;
        const embed = $embed.data('embed');
        $embed.html(embed);
        $embed.get(0).hidden = false;
        $poster.attr({ tabIndex: '-1' });
        gsap.timeline()
            .fromTo($embed.get(0), { opacity: 0 }, { opacity: 1, duration: 0.3 }, 0)
            .to($poster.get(0), { opacity: 0, duration: 0.3 }, 0);
    };

    const init = () => {
        $poster.on('click', onClick);
    };

    const destroy = () => {
        $poster.off('click');
    };

    return {
        init,
        destroy
    };

};
